import { useFormContext, useWatch } from "react-hook-form";
import { DiscountSettingsFormValues } from "./discount-settings-form";
import useTranslation from "@babackapp/translations/use-translation";

export function useDiscountDisabled() {
  const t = useTranslation();
  const { control } = useFormContext<DiscountSettingsFormValues>();

  const activated = useWatch<DiscountSettingsFormValues>({
    control,
    name: "activated",
  });

  return !activated
    ? t("settings.config.discount.errors.discountNotActivated")
    : false;
}

export function useFreeShippingFormDisabled() {
  const t = useTranslation();
  const { control } = useFormContext<DiscountSettingsFormValues>();

  const freeShippingActivated = useWatch({
    control,
    name: "discountFreeShippingActivated",
  });

  return !freeShippingActivated
    ? t("settings.config.discount.errors.freeShippingNotActivated")
    : false;
}

/**
 * Free shipping fields are disabled when the discount mode
 * is set to gift card
 */
export function useDiscountModeIncompatibleDisabled() {
  const t = useTranslation();
  const { control } = useFormContext<DiscountSettingsFormValues>();

  const mode = useWatch({
    control,
    name: "giftCard",
  });

  return (mode === "giftCard" || mode === "storeCredit")
    ? t("settings.config.discount.errors.discountModeIsGiftCard")
    : false;
}

/**
 * Bonus discount field is disabled when the discount mode
 * is set to store credit (store credit does not support bonuses)
 */
export function useStoreCreditBonusDisabled() {
  const t = useTranslation();
  const { control } = useFormContext<DiscountSettingsFormValues>();

  const mode = useWatch({
    control,
    name: "giftCard",
  });

  return mode === "storeCredit"
    ? t("settings.config.discount.errors.storeCreditNoBonusDiscount")
    : false;
}
